<template>
  <div class="shop-page">
    <div class="shop-center-box">
      <!-- 上半部分：轮播图+商品信息（左右两块） -->
      <div class="main-info-box">
        <div class="left">
          <div class="carousel">
            <swiper class="gallery-top" ref="swiperTop" :options="mainSwiperOption">
              <swiper-slide v-for="(img, idx) in images" :key="idx">
                <img :src="img" class="main-img" />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <swiper class="gallery-thumbs" ref="swiperThumbs" :options="thumbSwiperOption">
              <swiper-slide v-for="(img, idx) in images" :key="idx">
                <img :src="img" class="thumb-img" />
              </swiper-slide>
            </swiper>
          </div>

        </div>
        <div class="right">
          <div class="product-title">
            {{ detailObj.name }}
          </div>
          <div class="product-price-block">
            <div class="product-price">
              <span class="price">￥{{ currentProduct.price || 0 }}</span>
            </div>
            <div class="product-stock-sales">
              <span class="sales">累计销量：{{ detailObj.soldNum }}件</span>
              <span class="stock">库存：{{ detailObj.stockNum }}件</span>
            </div>
          </div>

          <div v-if="displayAddress" @click="editAddress('edit')" class="delivery-address"
            style="cursor:pointer; color:#409EFF; margin-top:8px;">
            配送至： {{ displayAddress.userName }},{{ displayAddress.phone }},{{ displayAddress.address }}
            <i class="el-icon-edit" style="margin-left:4px;"></i>
          </div>
          <div v-else>
            <el-button type="primary" size="mini" @click="editAddress('add')" style="margin-top:8px;">新增收货地址</el-button>
          </div>

          <!-- <el-divider></el-divider> -->

          <el-form label-width="80px" class="product-form">

            <el-form-item label="规格">
              <span>{{ detailObj.specification }}</span>
            </el-form-item>
            <el-form-item label="品牌">
              <span>{{ detailObj.brand }}</span>
            </el-form-item>
            <el-form-item label="商品套餐">
              <el-radio-group v-model="productId">
                <el-radio-button v-for="(item, index) in detailObj.productList" :key="item.productId"
                  :label="item.productId">
                  {{ item.specificationValue }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="运费">
              <span v-if="currentProduct.mailFlag == 1">免运费</span>
              <span v-else-if="currentProduct.mailFlag == 0">￥{{ ((currentProduct.mailPrice || 0) * num).toFixed(2)
                }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="购买数量">
              <el-input-number v-model="num" :min="1" :max="detailObj.stockNum" />
              <span class="stock-tip">库存：{{ detailObj.stockNum }}件</span>
            </el-form-item>
          </el-form>
          <div class="product-actions">
            <el-button type="success" @click="addToCart">加入购物车</el-button>
            <el-button type="primary" @click="buyNow">立即购买</el-button>
          </div>
          <el-divider></el-divider>
        </div>
      </div>

      <!-- 下半部分：旗舰店+商品评价 -->
      <div class="shop-extra-box">
        <div class="shop-info">
          <div class="comment-flex">
            <div>
              <i class="el-icon-user"></i>
              <span>{{ detailObj.shopName }}</span>
            </div>
            <div class="shop-kefu" v-if="customerList.length">
              <div class="kefu-item" v-for="(kefu, idx) in customerList" :key="kefu.id || idx"
                :class="{ active: activeKefu === (kefu.id || idx) }" @click="setActiveKefu(kefu)">
                <i class="el-icon-chat-line-round" :class="{ 'kefu-active': activeKefu === (kefu.id || idx) }"></i>
                <span>{{ kefu.realname || `客服${idx + 1}` }}</span>
              </div>
            </div>
            <div class="shop-kefu" v-else>
              <div class="kefu-item" @click="setActiveShop()">
                <i class="el-icon-chat-line-round"></i>
                <span>联系客服</span>
              </div>
            </div>

            <div class="shop-btn" style="margin-left:auto;">
              <el-button size="mini" @click="goShop">进入店铺</el-button>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 8px;">
          商品评价（{{ previewReviews.total }}条）
        </div>
        <div class="product-rating-bar">
          <div class="rating-bar-left">
            <div class="rating-bar-score">
              <span class="score">{{ reviewStats.avgScore || 0 }}</span>
              <el-rate :value="reviewStats.avgScore || 0" disabled allow-half :max="5" style="margin-left: 4px;" />
            </div>
            <div class="rating-bar-goodrate">
              好评率 {{ reviewStats.goodRate || 0 }}%
            </div>
          </div>
          <div class="rating-bar-right">
            <div class="rating-bar-row" v-for="item in ratingBarList" :key="item.star">
              <span class="star-label">{{ item.star }}星</span>
              <el-progress :percentage="item.percent" :stroke-width="10" color="#67c23a"
                style="width: 120px; margin: 0 12px;" :show-text="false" />
              <span class="star-percent">{{ item.num }}分</span>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
      <!-- 评价 -->
        <div class="product-comments">

          <div class="comment-item" v-for="(item, index) in previewReviews.records" :key="index">
            <div class="comment-flex">
              <el-avatar size="small" style="margin-right: 12px;">
                {{ item.userName && item.userName[0] }}
              </el-avatar>
              <div class="comment-main">
                <div class="comment-user">{{ formatUserName(item.userName) }}</div>
                <div class="comment-meta">
                  <el-rate :value="item.stars" disabled size="small" />
                  <span class="comment-date">{{ item.time }}</span>
                </div>
              </div>
            </div>
            <div class="comment-content">{{ item.content }}</div>
            <div v-if="item.img && (Array.isArray(parseImg(item.img)) ? parseImg(item.img).length : false)" class="comment-images">
              <el-image
                v-for="(img, idx) in parseImg(item.img)"
                :key="idx"
                :src="formatImgUrl(img.url)"
                :preview-src-list="parseImg(item.img).map(i => formatImgUrl(i.url))"
                style="width: 80px; height: 80px; margin: 4px; border-radius: 6px; object-fit: cover;"
                fit="cover"
              />

            </div>
          </div>
          

          <el-link type="primary" :underline="false" class="all-comments-link" @click="showCommentDialog = true">
            查看全部{{ previewReviews.total }}条评价
          </el-link>
        </div>
      </div>
      
      <!-- 商品详情部分 -->
      <el-divider></el-divider>
      <div class="product-detail-block">
        <div class="product-detail-title">商品详情</div>
        <div class="product-detail-content" v-html="detailObj.detail"></div>
      </div>

    </div>
    <!-- 商品评价弹窗 -->
    <el-dialog :visible.sync="showCommentDialog" width="700px" top="40px" class="comment-dialog"
      :close-on-click-modal="false" :show-close="true">
      <template #title>
        <div class="comment-dialog-title">
          <span>商品评价</span>
        </div>
      </template>
      <div class="comment-dialog-tabs">
        <el-tabs v-model="commentTab" @tab-click="handleClick">
          <el-tab-pane :label="`全部（${previewReviews.total || 0}条）`" name=" "></el-tab-pane>
          <el-tab-pane label="有图评论" name="0"></el-tab-pane>
          <el-tab-pane label="好评" name="1"></el-tab-pane>
          <el-tab-pane label="中评" name="2"></el-tab-pane>
          <el-tab-pane label="差评" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="comment-dialog-list">
        <div class="comment-item" v-for="(item, index) in previewReviews.records" :key="index">
          <div class="comment-flex">
            <el-avatar size="small" style="margin-right: 12px;">
              {{ formatUserName(item.userName) && formatUserName(item.userName)[0] }}
            </el-avatar>
            <div class="comment-main">
              <div class="comment-user">{{ formatUserName(item.userName) }}</div>
              <div class="comment-meta">
                <el-rate :value="item.stars" disabled size="small" />
                <span class="comment-date">{{ item.time }}</span>
              </div>
            </div>
          </div>
          <div class="comment-content">{{ item.content }}</div>
          <div v-if="item.img && (Array.isArray(parseImg(item.img)) ? parseImg(item.img).length : false)" class="comment-images">
            <el-image
              v-for="(img, idx) in parseImg(item.img)"
              :key="idx"
              :src="formatImgUrl(img.url)"
              :preview-src-list="parseImg(item.img).map(i => formatImgUrl(i.url))"
              style="width: 80px; height: 80px; margin: 4px; border-radius: 6px; object-fit: cover;"
              fit="cover"
            />
          </div>
        </div>
      </div>
      <!-- 可加分页 -->
    </el-dialog>
    <!-- 修改地址列表弹窗 -->
    <editAddressDialog :visible.sync="editAddressDialogVisible" :mySelfAddress.sync="mySelfAddress"
      @select="handleSelectAddress" />
    <!-- 新增地址弹窗 -->
    <!-- :regionOptions="regionOptions" -->
    <addAddress :visible.sync="addAddressDialogVisible" @save="handleAddAddress" />
  </div>
</template>

<script>
// 引入所需API和组件
import { mapGetters } from "vuex";
import { SendMessage } from "../../api/websocket";
import { appletPcDetail, list, addCart, orderSubmit, addressList, statisticsData } from '@/api/sjzx'
import editAddressDialog from '../memberCenter/nzfw/components/editAddressDialog.vue'
import addAddress from '../memberCenter/nzfw/components/addAddress.vue'
export default {
  data() {
    return {
      images: [], // 商品图片数组
      baseUrl: window.globalUrl.HOME_API, // 图片等资源基础URL
      mainSwiperOption: {
        loop: true, // 是否循环播放
        loopedSlides: 4, // 循环时克隆的幻灯片数，需与图片数量一致以保证循环正常
        slidesPerView: 1, // 每页显示的幻灯片数量
        spaceBetween: 10, // 幻灯片之间的间距（像素）
        pagination: { el: ".swiper-pagination", clickable: true }, // 分页器配置，el为分页器元素，clickable为是否可点击
        autoplay: { delay: 3000, stopOnLastSlide: false, disableOnInteraction: true }, // 自动播放配置
        speed: 800, // 切换速度（毫秒）
        watchSlidesVisibility: true, // 监控slide的可见性，配合缩略图联动
        watchSlidesProgress: true, // 监控slide的进度，配合缩略图联动

      },
      thumbSwiperOption: {
        // loop: true,
        loopedSlides: 4,
        slidesPerView: "auto",
        spaceBetween: 10,
        centeredSlides: true,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
      productId: 0, // 当前选中的商品套餐ID
      num: 1, // 购买数量
      activeKefu: '', // 当前激活的客服
      detailObj: {}, // 商品详情对象
      previewReviews: { total: 0, records: [] }, // 商品评论数据
      reviewStats: {}, // 评论区评分
      showCommentDialog: false, // 是否显示评论弹窗
      commentTab: '', // 当前评论tab
      selectedAddress: null, // 当前选中的地址
      mySelfAddress: [], // 用户地址列表
      editAddressDialogVisible: false, // 编辑地址弹窗显示
      addAddressDialogVisible: false, // 新增地址弹窗显示
      loading: false, // loading状态，防止重复提交
      customerList: [],//客服列表
      ratingBarList: [
        { star: 5, percent: 0, num: 0 },
        { star: 4, percent: 0, num: 0 },
        { star: 3, percent: 0, num: 0 }
      ],
    };
  },


  computed: {
    ...mapGetters(["identityObj"]),
  
    // 计算属性：用于显示的地址，优先选中地址，否则取默认地址，否则取第一个地址
    displayAddress() {
      
      // console.log(this.selectedAddress,'这里进行调用了')
      if (this.selectedAddress) return this.selectedAddress;
      // console.log('这里进行调用了')
      return this.mySelfAddress.find(addr => addr.defaultFlag === '1') || this.mySelfAddress[0] || null;
    },
    //选中第一个商品规格
    currentProduct() {
      if (!this.detailObj.productList) return {};
      return this.detailObj.productList.find(item => item.productId === this.productId) || {};
    }
  },
  components: { editAddressDialog, addAddress },
  mounted() {
    this.initShow();
    if (this.identityObj.identityId) {
      this.getAddressInfo()
    }

    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper;
      const swiperThumbs = this.$refs.swiperThumbs.$swiper;
      if (swiperTop && swiperThumbs) {
        swiperTop.controller.control = swiperThumbs;
        swiperThumbs.controller.control = swiperTop;
      }
    });

  },
  methods: {
    handleClick(tab, event) {
      //切换商品评价
      // console.log(tab, event,this.commentTab)
      this.getCommentList()
    },

    async getStatisticsData() {
      // 获取商品评论统计数据
      if (!this.detailObj.id) return;
      try {
        const res = await statisticsData({ goodsId: this.detailObj.id });
        if (res.code == 0) {
          let { fiveStarRate, fourStarRate, threestarRate, fiveStarCount, fourStarCount, threeStarCount } = res.data
          // 商品描述星级
          this.ratingBarList = [
            { star: 5, percent: fiveStarRate, num: fiveStarCount },
            { star: 4, percent: fourStarRate, num: fourStarCount },
            { star: 3, percent: threestarRate, num: threeStarCount }
          ]
          this.reviewStats = res.data
        }

      } catch (e) {
        this.$message.error('获取统计数据失败');
      }
    },
    // 跳转到店铺页面
    goShop() {
      // console.log(this.detailObj.shopId, '查看detailObj')
      this.$router.push({
        path: '/quickLink/agriServiceShop', query: { shopId: this.detailObj.shopId }
      })
    },
    // 编辑或新增地址弹窗
    editAddress(mode) {
      if (mode === 'edit') {
        this.editAddressDialogVisible = true;
      } else if (mode === 'add') {
        this.addAddressDialogVisible = true;
      }
    },
    // 获取用户地址信息
    async getAddressInfo() {
      this.loading = true;
      try {
        const res = await addressList();
        this.mySelfAddress = res.data.records || [];
        if (!this.selectedAddress) {
          this.selectedAddress = this.mySelfAddress.find(addr => addr.defaultFlag === '1') || this.mySelfAddress[0] || null;
        }
        // console.log(this.selectedAddress, '查看获取的收货地址')
      } catch (e) {
        this.$message.error('获取地址失败');
      } finally {
        this.loading = false;
      }
    },
    // 解析图片数据并赋值到images
    changeImgs(arr) {
      if (!arr) {
        this.images = [];
        return;
      }
      try {
        const newArr = JSON.parse(arr);
        this.images = Array.isArray(newArr)
          ? newArr.map(item => this.baseUrl + 'admin/file/get?ossFilePath=' + item.url)
          : [];
        const imgCount = this.images.length;
        // 重新赋值 options，确保响应式
        this.mainSwiperOption = {
          ...this.mainSwiperOption,
          loopedSlides: imgCount,
          loop: imgCount > 1,
        };
        this.thumbSwiperOption = {
          ...this.thumbSwiperOption,
          loopedSlides: imgCount,
          loop: imgCount > 1,
        };
        this.$nextTick(() => {
          // 重新绑定联动
          const swiperTop = this.$refs.swiperTop.$swiper;
          const swiperThumbs = this.$refs.swiperThumbs.$swiper;
          if (swiperTop && swiperThumbs) {
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
          }
        });
      } catch (e) {
        this.images = [];
      }
    },
    // 初始化商品详情数据
    async initShow() {
      let params = { id: this.$route.query.id }
      let res = await appletPcDetail(params)
      if (res.code == 0) {

        this.detailObj = res.data
        this.customerList = res.data.customerList || []
        //初始化轮播图的图片
        this.changeImgs(res.data.img)
        //初始化轮播图
        this.$nextTick(() => {
          const swiperTop = this.$refs.swiperTop.$swiper;
          const swiperThumbs = this.$refs.swiperThumbs.$swiper;
          swiperTop.controller.control = swiperThumbs;
          swiperThumbs.controller.control = swiperTop;
        });
        // 规格默认选中第一个
        if (this.detailObj.productList && this.detailObj.productList.length > 0) {
          this.productId = this.detailObj.productList[0].productId
        }
        this.getCommentList()
        this.getStatisticsData()
      }else{
        this.$message.error(res.msg)
      }
    },
    // 获取商品评论列表
    async getCommentList() {
      if (!this.detailObj.id) return;
      try {
        const res = await list({ goodsId: this.detailObj.id, type: this.commentTab });
        this.previewReviews = res.data || { total: 0, records: [] };
      } catch (e) {
        this.$message.error('获取评论失败');
      }
    },
    // 加入购物车
    async addToCart() {
      if (this.loading) return;
      this.loading = true;
      try {
        let params = { num: this.num, productId: this.productId };
        let res = await addCart(params);
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } finally {
        this.loading = false;
      }
    },
    // 立即购买，跳转到结算页
    async buyNow() {
      if (!this.selectedAddress) {
        this.$message.error('请先选择收货地址');
        return;
      }

      let params = {
        addressId: this.selectedAddress.id,
        buyNum: this.num,
        productId: this.productId,
      }
      let res = await orderSubmit(params)
      if (res.code == 0) {
        // console.log(this.currentProduct.price,'查看价格', this.currentProduct.mailPrice )
        let totalPrice = (this.currentProduct.price) * this.num + (this.currentProduct.mailFlag == 0 ? this.currentProduct.mailPrice * this.num : 0);
        // console.log(totalPrice,'查看totalPrice')
        this.$router.push({
          name: 'OrderSubmitSuccess', query: {
            orderId: res.data.orderId,
            totalPrice: totalPrice,
            orderType: '0'
          }
        })
        this.$message.success('即将跳转到结算页');
      }else{
        this.$message.error(res.msg);
      }
    
    },
    //去和商家沟通
    async setActiveShop() {

      let params = {
        messageList: [
          {
            //消息类型会话托管
            messageType: 16,
            content: JSON.stringify(this.detailObj),
          },
        ],
        senderType: this.identityObj.identityTypeCode,
        senderId: this.identityObj.identityId,
        sender: this.identityObj.realName,
        receiverType: '4',
        receiver: this.detailObj.shopName,
        receiverId: this.detailObj.companyId,
      }
      this.detailObj.goodsId = this.detailObj.id
       console.log(params,'查看params')
      let res = await SendMessage(params);
      if (res.code == 0) {
        this.$router.push({
        path: "/home/Chat",
        query: {
          isshow: true, // 你要传递的参数
          // isshow: true,
          data: this.detailObj,
          // identityId: this.detailObj.companyId,
          num: 16,
        },
      });
      } else {
        this.$message.error(res.msg)
      }
    },
    // 去和客服沟通
    async setActiveKefu(kefu) {
      // console.log(kefu, '查案kefu')

      // let params = {
      //   messageList: [
      //     {
      //       //消息类型会话托管
      //       messageType: 0,
      //       content: "",
      //     },
      //   ],
      //   senderType: this.identityObj.identityTypeCode,
      //   senderId: this.identityObj.identityId,
      //   sender: this.identityObj.realName,
      //   receiverType: kefu.userType,
      //   receiver: kefu.realname,
      //   receiverId: kefu.userId,
      // }
      // let res = await SendMessage(params);
      // if (res.code == 0) {
      //   this.$router.push({
      //     path: "/home/Chat",
      //     query: {
      //       isshow: false, // 你要传递的参数
      //       data: {
      //         type: true,
      //         identityId: kefu.userId,
      //       },
      //       num: 0,
      //     },
      //   });
      // }

      // console.log(kefu,'查看kefu')
      let params = {
        messageList: [
          {
            //消息类型会话托管
            messageType: 16,
            content: JSON.stringify(this.detailObj),
          },
        ],
        senderType: this.identityObj.identityTypeCode,
        senderId: this.identityObj.identityId,
        sender: this.identityObj.realName,
        receiverType: '36',
        receiver: kefu.realname,
        receiverId: kefu.userId,
      }
      this.detailObj.goodsId = this.detailObj.id
      // this.$router.push({
      //     path: "/home/Chat",
      //     query: {
      //       isshow: true, // 你要传递的参数
      //       // isshow: true,
      //       data: this.detailObj,
      //       // identityId: this.detailObj.companyId,
      //       num: 16,
      //     },
      //   });
      // console.log(params,'查看params')
      let res = await SendMessage(params);
      if (res.code == 0) {
        this.$router.push({
          path: "/home/Chat",
          query: {
            isshow: true, // 你要传递的参数
            // isshow: true,
            data: this.detailObj,
            // identityId: this.detailObj.companyId,
            num: 16,
          },
        });
      } else {
        this.$message.error(res.msg)
      }
    },
    // 新增地址后刷新地址列表
    handleAddAddress() {
      this.getAddressInfo()
    },
    // 选择地址
    handleSelectAddress(address) {
      this.selectedAddress = address;
    },
    parseImg(img) {
      if (!img) return [];
      if (typeof img === 'string') {
        try {
          const arr = JSON.parse(img);
          return Array.isArray(arr) ? arr : [];
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(img) ? img : [];
    },
    formatImgUrl(url) {
      if (!url) return '';
      if (url.startsWith('http')) return url;
      return this.baseUrl + 'admin/file/get?ossFilePath=' + url;
    },
    formatUserName(name) {
      if (!name) return '';
      return name[0] + '*'.repeat(name.length - 1);
    },
  },
};
</script>

<style scoped>
.shop-page {
  background: #fff;
  padding: 24px;
  min-height: 100vh;
}

.shop-center-box {
  width: 80%;
  margin: 0 auto;
}

.main-info-box {
  display: flex;
  align-items: stretch;
}

.left {

  width: 420px;
  height: 580px;
  margin-right: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.right {
  flex: 1;
  min-width: 400px;
  height: 100%;
}

.shop-extra-box {
  margin-top: 32px;
}

.carousel {
  width: 100%;
  height: 100%;
  margin-bottom: 12px;
  background: #f8fafd;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  padding: 0;
}

.gallery-top {
  width: 100%;
  height: 450px;
  flex-shrink: 0;
}

.gallery-thumbs {
  width: 100%;
  height: 250px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
}

.gallery-thumbs .swiper-slide {
  width: 120px;
  height: 100px;
  margin-right: 8px;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid transparent;
  transition: border 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gallery-thumbs .swiper-slide-active,
.gallery-thumbs .swiper-slide-thumb-active {
  border-color: #67c23a;
}

.main-img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 8px;
  display: block;
}

.thumb-img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 6px;
  display: block;
}

.shop-info {
  display: flex;
  align-items: center;
  margin: 16px 0;
  justify-content: flex-start;
}

.shop-info .comment-flex {
  flex: 1;
  display: flex;
  align-items: center;
}

.shop-btn {
  margin-left: auto;
}

.product-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
}

.product-price-block {
  background: #f8fafd;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  padding: 18px 20px 10px 20px;
  margin-bottom: 16px;
  box-sizing: border-box;
  width: 100%;
}

.product-price {
  color: #e4393c;
  font-size: 22px;
  margin-bottom: 8px;
}

.product-stock-sales {
  margin-bottom: 8px;
  color: #888;
  font-size: 14px;
}

.product-stock-sales .sales {
  margin-right: 24px;
}

.product-actions {
  margin: 18px 0;
}

.product-rating-bar {
  display: flex;
  align-items: center;
  margin: 24px 0 16px 0;
}

.rating-bar-left {
  width: 180px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 32px;
}

.rating-bar-score {
  display: flex;
  align-items: center;
  font-size: 32px;
  font-weight: bold;
  color: #13ce66;
  margin-bottom: 4px;
  white-space: nowrap;
}

.rating-bar-score .el-rate {
  margin-left: 8px;
  font-size: 22px;
  vertical-align: middle;
  line-height: 1;
}

.rating-bar-goodrate {
  font-size: 15px;
  color: #888;
  margin-top: 2px;
}

.rating-bar-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rating-bar-row {
  display: flex;
  align-items: center;
}

.star-label {
  width: 32px;
  font-size: 15px;
  color: #333;
}

.star-percent {
  width: 36px;
  text-align: right;
  color: #888;
  font-size: 15px;
}

.product-comments {
  margin-top: 16px;
}

.comment-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
}

.comment-item {
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 10px;
}

.comment-flex {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.comment-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.comment-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  margin-left: 0;
}

.comment-user {
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
}

.comment-date {
  color: #888;
  font-size: 12px;
}

.comment-content {
  color: #666;
  font-size: 14px;
}

.stock-tip {
  margin-left: 16px;
  color: #888;
  font-size: 14px;
}

.shop-kefu {
  display: flex;
  align-items: flex-end;
  margin-left: 16px;
}

.kefu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 40px;
  line-height: 1.1;
  margin-right: 8px;
  padding: 0 6px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
}

/* .kefu-item.active, .kefu-item:hover {
  background: #f0f7ff;
} */

.shop-kefu .el-icon-user {
  font-size: 20px;
  margin: 0 0 2px 0;
}

.kefu-active {
  color: #13ce66;
}

.kefu-item.active span {
  color: #13ce66;
}

.all-comments-link {
  display: block;
  text-align: center;
  margin: 12px 0 0 0;
}

.product-detail-block {
  margin-top: 32px;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.product-detail-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}

.product-detail-content {
  font-size: 15px;
  color: #333;
  line-height: 1.8;
  word-break: break-all;
}

.comment-dialog-title {
  font-size: 18px;
  font-weight: bold;
}

.comment-dialog .el-dialog__body {
  padding: 0 24px 24px 24px;
}

.comment-dialog-tabs {
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 8px;
}

.comment-dialog-list {
  max-height: 400px;
  overflow-y: auto;
  padding-top: 8px;
}

.gallery-thumbs .swiper-slide-thumb-active {
  border: 2px solid #67c23a;
}
</style>
